export default "__VITE_ASSET__uvkJNyTq__"